var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "van-sticky",
        [
          _c(
            "van-search",
            {
              attrs: {
                placeholder: "请输入委托编号、案名",
                "left-icon": "search",
                "show-action": _vm.userInfo.userType == 1,
                "right-icon": ""
              },
              on: { search: _vm.getFilterValue },
              model: {
                value: _vm.searchValue,
                callback: function($$v) {
                  _vm.searchValue = $$v
                },
                expression: "searchValue"
              }
            },
            [
              _c(
                "div",
                {
                  attrs: { slot: "action" },
                  on: { click: _vm.createNewSign },
                  slot: "action"
                },
                [_vm._v("预约")]
              )
            ]
          ),
          _c("FilterConfig", {
            attrs: { configs: _vm.filterList },
            on: { change: _vm.getFilterValue },
            model: {
              value: _vm.filterInfo,
              callback: function($$v) {
                _vm.filterInfo = $$v
              },
              expression: "filterInfo"
            }
          })
        ],
        1
      ),
      _c(
        "section",
        { staticClass: "list_body" },
        [
          _c(
            "van-list",
            {
              attrs: {
                finished: _vm.dataLoad.finished,
                error: _vm.dataLoad.error,
                "finished-text": "没有更多了",
                "error-text": "请求失败，点击重新加载"
              },
              on: {
                "update:error": function($event) {
                  return _vm.$set(_vm.dataLoad, "error", $event)
                },
                load: _vm.getList
              },
              model: {
                value: _vm.dataLoad.loading,
                callback: function($$v) {
                  _vm.$set(_vm.dataLoad, "loading", $$v)
                },
                expression: "dataLoad.loading"
              }
            },
            _vm._l(_vm.caseList, function(item) {
              return _c(
                "div",
                {
                  key: item.ID,
                  staticClass: "mobile-nav",
                  on: {
                    click: function($event) {
                      return _vm.checkDetail(item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "mobile-nav__item" }, [
                    _c(
                      "div",
                      { staticClass: "van-cell van-cell--clickable" },
                      [
                        _c(
                          "div",
                          { staticClass: "list_head" },
                          [
                            _c("span", { staticClass: "list_title" }, [
                              _vm._v(_vm._s(item.CaseName))
                            ]),
                            item.Status == "0"
                              ? _c(
                                  "van-tag",
                                  { attrs: { color: "#388CEB", plain: "" } },
                                  [_vm._v("待处理")]
                                )
                              : item.Status == "1"
                              ? _c(
                                  "van-tag",
                                  { attrs: { color: "#F5A623", plain: "" } },
                                  [_vm._v("已分配")]
                                )
                              : item.Status == "2"
                              ? _c(
                                  "van-tag",
                                  { attrs: { color: "#f56c6c", plain: "" } },
                                  [_vm._v("已取消")]
                                )
                              : item.Status == "3"
                              ? _c(
                                  "van-tag",
                                  { attrs: { color: "#7ED321", plain: "" } },
                                  [_vm._v("已完成")]
                                )
                              : _vm._e(),
                            _c(
                              "van-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.checkOperation(item)
                                  }
                                }
                              },
                              [_vm._v("操作")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          { attrs: { type: "flex" } },
                          [
                            _c("van-col", { attrs: { span: "12" } }, [
                              _c("span", { staticClass: "list_field" }, [
                                _vm._v("委托编号")
                              ]),
                              _c("span", { staticClass: "list_value" }, [
                                _vm._v(_vm._s(item.OrderNo))
                              ])
                            ]),
                            _c("van-col", { attrs: { span: "12" } }, [
                              _c("span", { staticClass: "list_field" }, [
                                _vm._v("预约日期")
                              ]),
                              _c("span", { staticClass: "list_value" }, [
                                _vm._v(_vm._s(item.AppointmentDateTime))
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          { attrs: { type: "flex" } },
                          [
                            _c("van-col", { attrs: { span: "12" } }, [
                              _c("span", { staticClass: "list_field" }, [
                                _vm._v("预约类型")
                              ]),
                              _c("span", { staticClass: "list_value" }, [
                                _vm._v(_vm._s(_vm.DoTypeStr(item.DoType)))
                              ])
                            ]),
                            _c("van-col", { attrs: { span: "12" } }, [
                              _c("span", { staticClass: "list_field" }, [
                                _vm._v("签约法务")
                              ]),
                              _c("span", { staticClass: "list_value" }, [
                                _vm._v(_vm._s(item.SignLegalUser))
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          { attrs: { type: "flex" } },
                          [
                            _c("van-col", { attrs: { span: "12" } }, [
                              _c("span", { staticClass: "list_field" }, [
                                _vm._v("预约区域")
                              ]),
                              _c("span", { staticClass: "list_value" }, [
                                _vm._v(_vm._s(item.AppointmentDistrict))
                              ])
                            ]),
                            _c("van-col", { attrs: { span: "12" } }, [
                              _c("span", { staticClass: "list_field" }, [
                                _vm._v("办理人员")
                              ]),
                              _c("span", { staticClass: "list_value" }, [
                                _vm._v(_vm._s(item.DoUserName))
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _c("van-action-sheet", {
        attrs: { actions: _vm.operationList },
        on: { select: _vm.showOperation },
        model: {
          value: _vm.operationShow,
          callback: function($$v) {
            _vm.operationShow = $$v
          },
          expression: "operationShow"
        }
      }),
      _c(
        "van-action-sheet",
        {
          attrs: { title: "预约新增" },
          model: {
            value: _vm.addSignShow,
            callback: function($$v) {
              _vm.addSignShow = $$v
            },
            expression: "addSignShow"
          }
        },
        [
          _c(
            "div",
            [
              _c("van-field", {
                attrs: {
                  clearable: "",
                  label: "委托编号",
                  placeholder: "请输入委托编号"
                },
                model: {
                  value: _vm.addSignOrderNo,
                  callback: function($$v) {
                    _vm.addSignOrderNo = $$v
                  },
                  expression: "addSignOrderNo"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "action-sheet-foot" },
            [
              _c(
                "van-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.addSignShow = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "van-button",
                {
                  attrs: {
                    type: "text",
                    size: "mini",
                    disabled: !_vm.addSignOrderNo
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.addSign($event)
                    }
                  }
                },
                [_vm._v("预约")]
              )
            ],
            1
          )
        ]
      ),
      _vm.isWechat
        ? _c(
            "van-row",
            { staticClass: "button_group" },
            [
              _c(
                "van-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "van-button",
                    {
                      attrs: {
                        plain: "",
                        block: "",
                        square: "",
                        type: "warning"
                      },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("返回")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }